import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, take, tap } from 'rxjs';

import { OwnAccountDTO } from '../../../../common/dtos/own-account.dto';
import { ACCOUNT_ID_PARAM } from '../../../constants/application-routes';
import { resetGrantRevokePermissionState } from '../../../store/actions/grant-revoke-permissions.action';
import { updateRemoveUserStepperSelectedAccount } from '../../../store/actions/remove-user-stepper-flow.action';
import { selectAccountById } from '../../../store/selectors/account-permissions.selector';
import { selectConfirmationNumber } from '../../../store/selectors/grant-revoke-permissions.selector';
import { PageComponent } from '../page.component';
import { FlowKey } from 'src/app/enums/flow-keys.enum';
import { StepperComponent } from '../../stepper/stepper.component';
import { AsyncPipe } from '@angular/common';
import { RemoveUserConfirmationPageComponent } from '../remove-user-confirmation-page/remove-user-confirmation-page.component';

@Component({
    selector: 'zci-remove-user-from-account-page',
    templateUrl: './remove-user-from-account-page.component.html',
    styleUrls: ['./remove-user-from-account-page.component.scss'],
    imports: [
        AsyncPipe,
        StepperComponent,
        RemoveUserConfirmationPageComponent,
    ],
})
export class RemoveUserFromAccountPageComponent extends PageComponent implements OnInit, OnDestroy {
    private readonly activatedRoute = inject(ActivatedRoute);
    private store = inject(Store);

    FlowKey = FlowKey;
    accountId: string;

    confirmationNumber$: Observable<string> = this.store.select(selectConfirmationNumber);

    ngOnInit(): void {
        this.accountId = this.activatedRoute.snapshot.params[ACCOUNT_ID_PARAM];
        this.storeSelectedAccount();
    }

    ngOnDestroy(): void {
        this.store.dispatch(resetGrantRevokePermissionState());
    }

    private storeSelectedAccount() {
        this.store
            .select(selectAccountById(this.accountId))
            .pipe(
                take(1),
                tap((selectedAccount: OwnAccountDTO) => {
                    this.store.dispatch(
                        updateRemoveUserStepperSelectedAccount({
                            selectedAccount: selectedAccount,
                        }),
                    );
                }),
            )
            .subscribe();
    }
}
